import React from 'react';
import moment from 'moment';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import InputAdornmentComponent from '../Input-adornment/Input-adornment.component';
import useDictionary from '@ui/hooks/useDictionary';
import { size } from './size';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    label,
    helperText,
    tooltip,
    id,
    disabled,
    minTime,
    maxTime,
    value,
    error,
    onChange,
    onError,
    onInputClick,
}: IProps) => {
    const getWord = useDictionary();

    const getInput = (params: TextFieldProps): React.ReactElement => {
        const props = {
            ...params,
            className: 'time-input',
            InputProps: {
                ...params.InputProps,
                placeholder: '',
                startAdornment: (
                    <InputAdornmentComponent
                        lang={lang}
                        data={getWord(tooltip)}
                    />
                ),
            },
            error,
            id,
            helperText: helperText ? getWord(helperText) : undefined,
            onClick: onInputClick,
            onFocus: onInputClick,
            label: getWord(label),
            size: 'small' as size,
        };
        return (
            <>
                <TextField {...props} />
            </>
        );
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} locale={lang}>
            <TimePicker
                renderInput={getInput}
                inputFormat="HH:mm"
                mask="__:__"
                disabled={disabled}
                value={value}
                minTime={minTime ? moment().set(minTime) : undefined}
                maxTime={maxTime ? moment().set(maxTime) : undefined}
                onChange={onChange}
                onError={onError}
                ampm={false}
                toolbarTitle={getWord('timePickerTitle')}
            />
        </LocalizationProvider>
    );
};

const TimeInputComponent = React.memo(Component);

export default TimeInputComponent;
